import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: [],
  keyword: "",
  loading: false,
  listRole: [],
};

export const Profile = createSlice({
  name: "profile",
  initialState,
  reducers: {
    ChangeData: (state, action) => {
      state.data = action.payload;
    },
    ChangeKeyword: (state, action) => {
      state.keyword = action.payload;
    },
    ChangeLoading: (state, action) => {
      state.loading = action.payload;
    },
    ChangeListRole: (state, action) => {
      state.listRole = action.payload;
    },
  },
});

export const {
  ChangeData,
  ChangeKeyword,
  ChangeLoading,
  ChangeListRole,
} = Profile.actions;

export default Profile.reducer;
